import useSummary from 'data/hooks/useSummary';
import { sub } from 'date-fns';
import { getWeekDays, getWeekRange } from 'utils/getWeek';
import { today } from 'components/Form/WeekRangePicker/utils';
import { useEffect, useState } from 'react';
import { HoverRange } from 'data/types/hoverRange';
import { Props } from './types';

const useConnect = ({ brandId }: Props) => {
  const { summary, isLoading, refetch } = useSummary(brandId);
  const hoverRangeDefault = {
    from: undefined,
    to: undefined,
  };
  const [hoverRange, setHoverRange] = useState<HoverRange>(hoverRangeDefault);
  const [selectedDays, setSelectedDays] = useState<Date[]>(
    getWeekDays(sub(today, { weeks: 2 })),
  );
  const handleDayChange = (date: Date) => {
    const days = getWeekDays(date);
    setSelectedDays(days);
  };
  const handleDayEnter = (date: Date) => {
    const days = getWeekRange(date);
    setHoverRange(days);
  };
  const handleDayLeave = () => {
    setHoverRange(hoverRangeDefault);
  };
  const handleWeekClick = (weekNumber: any, days: Date[]) => {
    setSelectedDays(days);
  };

  useEffect(() => {
    if (brandId !== '') {
      refetch();
    }
  }, [refetch, brandId]);

  return {
    hoverRange,
    selectedDays,
    handleDayChange,
    handleDayEnter,
    handleDayLeave,
    handleWeekClick,
    summary,
    isLoading,
  };
};

export default useConnect;
